import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { ContenidoCertificadoService } from './contenido-certificado.service';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { filter } from 'rxjs/operators';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';

@Component({
	selector: 'app-contenido-certificado',
	templateUrl: './contenido-certificado.component.html',
	styleUrls: ['./contenido-certificado.component.scss']
})
export class ContenidoCertificadoComponent implements OnInit {

	dataTabla: DatoPaginadoModel;
	headerContenidoCertificado: Array<string>;
	formContenidoCertificado: FormGroup;
	selectContenidoCertificado: any;

	paginaActual: number;
	// filtros
	filtro: FormGroup;
	public isCollapsed = true;

	// Selects
	camaraComercio: Array<any> = [];

	constructor(private formBuilder: FormBuilder, private contenidoCertificadoService: ContenidoCertificadoService,
		private modalService: NgbModal) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;

		this.createForm();
		this.consultarListas();

		this.selectContenidoCertificado = null;
		this.paginaActual = 1;

	}

	ngOnInit() {
		this.headerContenidoCertificado = ['Contenido Certificado ID', 'Cámara de Comercio',
			'Descripción', 'Ruta URL', 'Nombre Archivo', 'Contenido', 'Acceso Público', 'Estado', 'Acción'];

		this.onConsultarContenidoCertificado(1);
	}

	createForm() {
		this.formContenidoCertificado = this.formBuilder.group({
			contenido_certificado_id: [null, Validators.required],
			codigo_camara: [null, Validators.required],
			descripcion: [null, Validators.required],
			ruta: [null, Validators.required],
			nombre_archivo: [null, Validators.required],
      acceso_publico: [0, Validators.required],
			contenido: [null],
			activo: [true],

		});

		this.filtro = this.formBuilder.group({
			contenido_certificado_id: [null],
			codigo_camara: [null],
			descripcion: [null],
			ruta: [null],
			nombre_archivo: [null],
			contenido: [null],
			activo: [null],
      acceso_publico: [null]
		});
	}

	onConsultarContenidoCertificado(page: number) {
		this.contenidoCertificadoService.getContenidos(page, { ...this.filtro.value })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarContenidoCertificado(value);
	}

	onAgregarContenidoCertificado() {

		this.contenidoCertificadoService.create({
			...this.formContenidoCertificado.value, activo: 1, acceso_publico: 0
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarContenidoCertificado(this.paginaActual);
					this.formContenidoCertificado.reset();
				}
			});
	}

	onOperarContenidoCertificado() {
		if (!this.selectContenidoCertificado) {
			this.onAgregarContenidoCertificado();
		} else {
			this.onModificarContenidoCertificado();
		}
	}

	onCargarContenidoCertificado(entry: any) {
		entry.activo = entry.activo ? 1 : 0;
    entry.acceso_publico = entry.acceso_publico ? 1 : 0;
		this.formContenidoCertificado.patchValue({
			...entry
		});
		this.selectContenidoCertificado = entry;
	}

	onEliminarContenidoCertificado(entry: any) {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then(() => {
			this.contenidoCertificadoService.delete(entry).subscribe(resultado => {
				if (resultado.result) {
					// tslint:disable-next-line:max-line-length
					const index = this.dataTabla.items.map(function (e) { return e.contenido_certificado_id; }).indexOf(entry.contenido_certificado_id);
					this.dataTabla.items.splice(index, 1);
					this.selectContenidoCertificado = null;
					this.formContenidoCertificado.reset();
				}
			});
		});
	}

	onModificarContenidoCertificado() {
		this.contenidoCertificadoService.update({
			...this.formContenidoCertificado.value,
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarContenidoCertificado(this.paginaActual);
					this.formContenidoCertificado.reset();
					this.selectContenidoCertificado = null;
				}
			});
	}

	consultarListas() {
		this.contenidoCertificadoService.getCamaraComercio().subscribe(resultado => {
			if (resultado.data) {
				this.camaraComercio = resultado.data;
			}
		});
	}

	filtrar() {
		this.paginaActual = 1;
		this.onConsultarContenidoCertificado(1);
	}

	limpiar() {
		this.filtro.reset();
		this.filtrar();
	}
	limpiarContenidoCertificado() {
		this.formContenidoCertificado.reset();
		this.selectContenidoCertificado = null;
		this.createForm();
	}
}
